import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSparkles } = FiIcons;

function ChatMessage({ message }) {
  const isStudent = message.sender === 'student';

  return (
    <motion.div
      animate={{ opacity: 1, y: 0 }}
      className={`message-row ${isStudent ? 'student' : 'tutor'}`}
      initial={{ opacity: 0, y: 8 }}
    >
      {!isStudent && (
        <span className="tutor-avatar">
          <SafeIcon icon={FiSparkles} />
        </span>
      )}
      <div className="message-stack">
        <div className="message-bubble">{message.text}</div>
        <span className="message-time">
          {isStudent ? 'You' : 'Nova'} · {message.timestamp}
        </span>
      </div>
    </motion.div>
  );
}

export default ChatMessage;